module.exports = __webpack_public_path__ + "static/media/ten.aac55c83.svg";